import type { StyleRule } from '@archipro-design/aria';

export const CartSummary: StyleRule = ({ theme }) => ({
    justifyContent: 'space-between',
    padding: `0 ${theme.siteVariables['spaces']['space-16']}`,
    marginBottom: theme.siteVariables['spaces']['space-32'],
});
